
const config = {
    baseUrl: "https://pray.russia-church.com"
}
export {
    config
}